import { Block, Inline } from '@contentful/rich-text-types';
import { FC, PropsWithChildren, useMemo } from 'react';
import { DefaultLink } from '../Links/DefaultLink';
import { AllowedColors } from '.';
import { useLinksV2 } from '~/hooks/useLinksV2';

export const EntryHyperlink: FC<
  PropsWithChildren<{ color: string; node: Block | Inline }>
> = ({ children, color, node }) => {
  const { getLink } = useLinksV2();

  const link = useMemo(() => {
    const id = node?.data?.target?.sys?.id;
    return id ? getLink(id) ?? undefined : undefined;
  }, [getLink, node?.data?.target?.sys?.id]);

  if (!link) {
    return <>{children}</>;
  }

  return (
    <DefaultLink href={link.path} color={color as AllowedColors}>
      {children}
    </DefaultLink>
  );
};
